var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isNotify)?_c('el-header',{staticClass:"secondary-header notify-file-purge-banner"},[_vm._v(" "+_vm._s(_vm.label)+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }